export default __webpack_public_path__ + "static/9-e937ac49f2a5ecafd98c6d954a8abe21.webp";